import { Link } from 'react-router-dom';
import { Trans, useTranslation } from 'react-i18next';
import { Alert, Anchor } from '@mantine/core';

import { Modal } from 'components/shared';
import type { Form } from 'types';

import { FormSharingOptions } from '../FormSharingOptions';

type Props = {
  form: Form;
  isOpen: boolean;
  onClose: () => void;
};

export const FormSharingModal = ({ form, isOpen, onClose }: Props) => {
  const { t } = useTranslation('forms');

  return (
    <Modal
      size="md"
      title={t('common.formSharingModal.title')}
      isOpen={isOpen}
      onClose={onClose}
      defaultButtonText={t('common.formSharingModal.closeButton')}
      defaultButtonAction={onClose}
    >
      <Alert
        sx={theme => ({ marginBottom: theme.other.spacing(2) })}
        variant="outline"
        color="green"
        title={t('common.formSharingModal.alertTitle')}
      >
        <Trans
          i18nKey="forms:common.formSharingModal.alertMessage"
          components={{
            a: (
              <Anchor
                component={Link}
                onClick={() => onClose()}
                to={`/forms/${form.id}?sidebar=sharing`}
              />
            ),
          }}
        />
      </Alert>
      <FormSharingOptions form={form} disableSlugReset />
    </Modal>
  );
};
